<template>
  <div>
    <notifications group="foo" />
    <!--begin::Content header-->
    <div
      class="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10"
    ></div>
    <!--end::Content header-->

    <!--begin::Signin-->
    <div class="login-form login-signin" style="min-width: 350px" id="page">
      <div class="text-center mb-10 mb-lg-20">
        <h3 class="font-size-h1">Mot de passe oublié</h3>
        <p class="text-muted font-weight-semi-bold">Entrez votre email</p>
      </div>

      <!--begin::Form-->
      <b-form class="form" @submit.stop.prevent="onSubmit">
        <div
          role="alert"
          v-bind:class="{ show: errors.length }"
          class="alert fade alert-danger"
        >
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error }}
          </div>
        </div>

        <b-form-group
          id="example-input-group-1"
          label=""
          label-for="example-input-1"
        >
          <b-form-input
            placeholder="Email"
            class="form-control form-control-solid h-auto py-5 px-6"
            id="example-input-1"
            name="example-input-1"
            v-model="$v.form.email.$model"
            :state="validateState('email')"
            aria-describedby="input-1-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback">
            Un email est requis et une adresse e-mail valide.
          </b-form-invalid-feedback>
        </b-form-group>

        <!--begin::Action-->
        <div
          class="form-group d-flex flex-wrap justify-content-between align-items-center"
        >
          <router-link
            to="/login"
            class="text-dark-60 text-hover-primary my-3 mr-2"
            id="kt_login_forgot"
          >
            Annuler
          </router-link>
          <button
            ref="kt_login_signin_submit"
            class="btn btn-primary font-weight-bold px-9 py-4 my-3 font-size-3"
          >
            Envoyer
          </button>
        </div>
        <!--end::Action-->
      </b-form>
      <!--end::Form-->
    </div>
    <!--end::Signin-->
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>

<script>
//import { mapState } from "vuex";
//import { LOGIN, LOGOUT } from "@/core/services/store/auth.module";

//import { SELECT_PHARMACY } from "../../../core/services/store/pharmacy.module";

//import UserService from "../../../services/user.service";

import { validationMixin } from "vuelidate";
import { email, required } from "vuelidate/lib/validators";
import AuthService from "../../../services/auth.service";

export default {
  mixins: [validationMixin],
  name: "forgotpassword",
  data() {
    return {
      errors: [],
      form: {
        email: "",
      },
    };
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        email: null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      const email = this.$v.form.email.$model;

      AuthService.sendForgotPasswordCode(email)
        .then((result) => {
          switch (result.data.state) {
            case 1:
            case 4:
              this.$router.push({
                path: "/resetpassword",
                query: { email: email },
              });
              break;
            case 2:
              this.$notify({
                group: "foo",
                title: "Erreur",
                text:
                  "Trop de demandes, merci de réessayer dans quelques minutes.",
                type: "danger",
              });
              break;
            default:
          }

          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        })
        .catch(() => {
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    },
  },
  computed: {
    // ...mapState({
    //   errors: (state) => state.auth.errors,
    // }),
  },
};
</script>
